module.exports = __webpack_public_path__ + "img/beton.45b70b3c.png";